// TODO: these needs to be added to Craft
const staticUiText = {
  print_user_manual: "user manual",
  print_video_watch: "watch video on Youtube",
  glossary_definitions: "Glossary Definitions",
  screen_contact: "Contact",
  link_pdf_view_pre_manualname: "View a PDF version of this",
  pdf_create_cta: "Create PDF",
  pdf_download_cta: "Download PDF",
  print_loading: "Loading...",
  pdf_loading_message: "This may take up to a minute.",
};

const resolveGlobals = (globals, liveType = false) => {
  // Find the customer support set using the handle
  const customerSupportSet = globals.find(
    item => item.handle === "customerSupport"
  );

  // If customerSupportSet exists, extract localeSupportInfo, otherwise set to an empty array
  const contact = customerSupportSet
    ? customerSupportSet.localeSupportInfo
    : [];

  // Find the translations set using the handle
  const translationSet = globals.find(item => item.handle === "translations");

  // If translationSet exists, extract translationKeyValuePairs, otherwise set to an empty array
  const uiText = translationSet ? translationSet.translationKeyValuePairs : [];

  return {
    contact: contact.map(
      ({ localeTitle, addressLine1, addressLine2, ...rest }) => ({
        title: localeTitle,
        addressLine1: addressLine1 ?? "",
        addressLine2: addressLine2 ?? "",
        ...rest,
      })
    ),
    uiText: uiText.reduce((acc, cur) => {
      const key = cur.labelKey;
      const val = cur.labelValue;

      return {
        ...acc,
        [key]: val,
      };
    }, staticUiText),
  };
};

export default resolveGlobals;
